import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

/*
 * This component is built using `gatsby-image` to automatically serve optimized
 * images with lazy loading and reduced file sizes. The image is loaded using a
 * `StaticQuery`, which allows us to load the image from directly within this
 * component, rather than having to pass the image data down from pages.
 *
 * For more information, see the docs:
 * - `gatsby-image`: https://gatsby.dev/gatsby-image
 * - `StaticQuery`: https://gatsby.dev/staticquery
 */

const HomepageCollage = () => (
  <StaticQuery
    query={graphql`
      query {
        collage: file(
          relativePath: { eq: "gtri-historical-archive-collage.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 1110) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={data => (
      <Img
        fluid={data.collage.childImageSharp.fluid}
        style={{ height: "100%", width: "100%" }}
      />
    )}
  />
)
export default HomepageCollage
